'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	type: 'SUB_MENU_ITEM',
	name: 'Sub menu item',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*', '!SUB_MENU_ITEM'],
	category: 'Nav',
	props: [{
		name: 'name',
		inputType: 'text',
		label: 'Name',
		default: ''
	}, {
		name: 'url',
		inputType: 'link',
		label: 'Link',
		default: '',
		requestKey: 'linkFriendlyName'
	}]
};